import { Directive, HostBinding, Input } from '@angular/core';

@Directive({
	selector: '[matSelectSearchOption]',
})
export class MatSelectSearchOptionDirective {
	@HostBinding('class.mat-select-search-option--no-results') @Input() isNoResults = false;
	@HostBinding('class') elementClass = 'mat-select-search-option';
}
